import React, { Component } from "react";
import { Link } from "react-router-dom";
import MainLayout from "../../mainLayout";
import TextField from "../../component/TextField";
import Loader from "../../component/loader";
import AddFileIcon from "../../icons/plusicon";
import CopyIcon from "../../icons/copyicon";
import TextEditor from "../../component/TextEditor";
import Slider from "react-slick";
import UploadForm from "../../component/fpg/create/UploadForm";
import { Player, ControlBar, PlayToggle } from "video-react";
import PlusIcon from "./../../icons/plusicon";
//import AWS from "aws-sdk";
import AWS from "aws-sdk";
//moment import
import moment from "moment-timezone";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//Service import
import service from "../../services";
// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import DeletefileIcon from "../../icons/DeletefileIcon";
import PopUpCustomAll from "../../component/fpg/create/popUpCustomAll";
import commonImage from "../../commonImage";

let sub;

const EXT_IMAGES = /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i;
const EXT_VIDEO = /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;

const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {}
    }
  ]
};

export default class Accessibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      previewRecordEvents:[],
      activetab: 0,
      loaderFlag: false,
      imagePreloader: false,
      getAllHowToFestdetails: "",
      editorState: EditorState.createEmpty(),
      body: EditorState.createEmpty(),
      paragraph: EditorState.createEmpty(),
      title: "",
      media: [
        {
          _id: Math.random(),
          inSite: "",
          link: ""
        },
        {
          _id: Math.random(),
          inSite: "",
          link: ""
        },
        {
          _id: Math.random(),
          inSite: "",
          link: ""
        }
      ],
      data: [
        {
          label: "Add/Edit Content",
          Content: ""
        }
      ]
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount() {
    this.getHowToFestPlatform();
    this.getHowToFestPlatformEvent();
    this.setState({
      loaderFlag: true
    });
  }

  TabClick = index => {
    this.setState({
      activetab: index
    });
  };

  getHowToFestPlatformEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "howToFestInPerson|accessibility|getDetail":
          if (!response.error) {
            if (this.state.body) {
              const blocksFromHtml = htmlToDraft(response.data.body ? response.data.body : "");
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
              const body = EditorState.createWithContent(contentState);
              this.setState({
                body: body
              });
            }

            if (this.state.paragraph) {
              const blocksFromHtml = htmlToDraft(response.data.paragraph ? response.data.paragraph : "");
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
              const paragraph = EditorState.createWithContent(contentState);
              this.setState({
                paragraph: paragraph
              });
            }

            var media =
              response.data &&
              response.data.media &&
              response.data.media.map(image => {
                var imageData = {
                  _id: Math.random(),
                  inSite: image.inSite,
                  link: image.link
                };
                return imageData;
              });
            if (media) {
              this.setState({
                getAllHowToFestPlatformdetails: response.data,
                error: response.data.error,
                loaderFlag: false,
                title: response.data.title,
                media: media !== undefined ? media : this.state.media
              });
            } else this.setState({ loaderFlag: false });
          } else this.setState({ loaderFlag: false });

          break;
        case "howToFestInPerson|accessibility|create":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.apiserve.success("howToFestInPerson accessibility updated successful.");
            });
            this.getHowToFestPlatform()
          }
          break;
        case "howToFestInPerson|getLastUpdated":
          this.setState({
            getLastUpdated: response.data
          });
          break;
      }
    });
  };

  getHowToFestPlatform = () => {
    this.apiserve.sendevent("howToFestInPerson|accessibility|getDetail", {});
    this.apiserve.sendevent("howToFestInPerson|getLastUpdated", { type: "InPersonAccessibility" });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false
    });
  };

  handleVideo = (id, e) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = (event) => {
      this.setState(
        {
          file: file
          // base64: reader.result
        },
        () => {
          this.videoUp.value = "";

          if (file.size > 100e6) {
            this.setState({
              errorPopup: true,
              errorMsg: "Please upload a video smaller than 100 MB"
            });
            return false;
          }

          if (file.type === "video/mp4") {
            setTimeout(() => {
              this.videoUpload(file, id,event.target.result);
            }, 500);
          } else {
            this.setState({
              errorPopup: true,
              errorMsg: "Please upload only MP4 file"
            });
          }
        }
      );
    };
  };

  videoUpload = (file, id, img) => {
    // this.setState({ videoPreLoader: true });
    // var fileSet= commonImage(file,false,'',img)
    //  fileSet.then((value) => {
    //   this.state.media.forEach(image => {
    //     const imagePreloaderId = `imagePreloader_${id}`;
    //     const newState = { ...this.state };
    //     newState[imagePreloaderId] = false;
    //     this.setState(newState);
    //     if (image._id === id) {
    //       image.inSite = "";
    //       image.link = data && data.Location;
    //     }
    //   });
    //   this.setState({ videoPreLoader: false });
    // });
    this.setState({ videoPreLoader: true });
    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
      const { media: media } = this.state;

        media.forEach(image => {
        if (image._id === id) {
          image.inSite = value;
          image.link=''
          // image.link = data && data.Location;
        }
      });
      this.setState({ videoPreLoader: false, [`imagePreloader_${id}`]: false, media });
    });
  };

  onChangeFile = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file
        // base64: reader.result
      });
      if (file.type === "video/mp4") {
        // this.videoUp.value = "";

        if (file.size > 100e6) {
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please upload a video smaller than 100 MB"
          });
          return false;
        }

        if (file.type === "video/mp4") {
          setTimeout(() => {
            this.videoUpload(file, id,event.target.result);
          }, 500);
        } else {
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please upload only MP4 file"
          });
        }
      } else if (
        (file && file.type === "image/png") ||
        (file && file.type === "image/jpg") ||
        (file && file.type === "image/jpeg")
      ) {
        const fileList = Math.round(file && file.size / 1024);
        if (fileList >= 2048) {
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please upload a file smaller than 2 MB"
          });
          return false;
        }
        if (
          (file && file.type === "image/png") ||
          (file && file.type === "image/jpg") ||
          (file && file.type === "image/jpeg")
        ) {
          setTimeout(() => {
            this.imageUpload(file, id,event.target.result);
          }, 0);
        } else {
          this.setState({
            errorMsg: true,
            errorMsgShow: "Please upload a file for PNG,JPG or JPEG"
          });
        }
      } else {
        if (file && file.type.includes("image")) {
          const fileList = Math.round(file && file.size / 1024);
          if (fileList >= 2048) {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file smaller than 2 MB"
            });
            return false;
          }
          if (
            (file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")
          ) {
            return false;
          } else {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file for PNG,JPG or JPEG"
            });
          }
        } else {
          if (file.size > 100e6) {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a video smaller than 100 MB"
            });
            return false;
          }

          if (file.type === "video/mp4") {
            return false;
          } else {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload only MP4 file"
            });
          }
        }
      }
    };
  };

  checkURLImage(url) {
    return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
  }

  imageUpload = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state, imagePreloader: true };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
      this.state.media.forEach(image => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state };
        newState[imagePreloaderId] = false;
        this.setState(newState);
        if (image._id === id) {
          image.inSite = value;
        }
      });
      this.setState({ imagePreloader: false });
    });
  };
  onEditorStateChange = paragraph => {
    this.setState({
      paragraph: paragraph
    });
  };
  onEditorState = body => {
    this.setState({
      body: body
    });
  };
  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  onPasteLink = (e, id) => {
    const { name, value } = e.target;
    const media = Object.assign([], this.state.media);
    media.map(m => {
      if (m._id === id) {
        m.link = value;
        // m.inSite = value;
        m.inSite = '';
      }
      return m;
    });
    this.setState({ media });
  };
  submitFn = async e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const name = convertToRaw(this.state.paragraph.getCurrentContent());
      const paragraph = draftToHtml(name);
      const data = convertToRaw(this.state.body.getCurrentContent());
      const body = draftToHtml(data);
      // const media = {
      //     inSite: this.state.image,
      //     link: this.state.link
      // }
      let updateHowToFest = {
        id: this.state._id,
        title: this.state.title,
        paragraph: paragraph,
        body: body,
        media: this.state.media
      };
      this.apiserve.sendevent("howToFestInPerson|accessibility|create", updateHowToFest);
    }
  };
  setDeleteImagePopup = (id) => {
    this.setState({
      deleteImagePopup:true,
      deleteId:id
    })
}
  onDeleteImagePopup = () => {
    this.state.media.forEach(image => {
      if (image._id === this.state.deleteId) {
        image.inSite = "";
      }
    });
    this.setState({
        deleteImagePopup:false
    })
  }
  closeAdminUser = () => {
  this.setState({  deleteImagePopup:false})
  };

  previewRecordHTF = (e) => {
    e.preventDefault()
    let updateHowToFest={}
    if (this.validator.allValid()) {
      // this.setState({ loaderFlag: true });
      const name = convertToRaw(this.state.paragraph.getCurrentContent());
      const paragraph = draftToHtml(name);
      const data = convertToRaw(this.state.body.getCurrentContent());
      const body = draftToHtml(data);
      // const media = {
      //     inSite: this.state.image,
      //     link: this.state.link
      // }
     updateHowToFest = {
        id: this.state._id,
        title: this.state.title,
        paragraph: paragraph,
        body: body,
        media: this.state.media,
        tabIndex:4,
        // tabActive:true
      };
    }
      let previewRecordEvents = this.apiserve.encrypt(updateHowToFest)
    window.open(process.env.REACT_APP_FRONTEND_ORIGIN_HTF + 'htf-inperson-preview?data=' + previewRecordEvents); 
    // this.setState({ loaderFlag: false });
}

  render() {
    const { getLastUpdated } = this.state;
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment.tz(updateAt, "US/Mountain").format("h");
    var minutes = moment.tz(updateAt, "US/Mountain").format("mm");
    var state = moment.tz(updateAt, "US/Mountain").format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    const self = this;
    return (
      <React.Fragment>
        <div className="right_side_wrapper artistView_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      <div>{list.label}</div>
                    </p>
                  </li>
                );
              })}
          </ul>
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <p></p>
            <p className="update_date">
              Last Update: {hour}:{minutes} {state} - {moment.tz(updateAt, "US/Mountain").format("MM/DD/YYYY")} Last Updated By:{" "}
              {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}
            </p>
          </div>
          <div className="fest_contents fpg_tabcontent fpg_tabcontent">
            <form>
              <div className="d_flex">
                <div className="video_slider uploads_files">
                <p className="fest_field_title">Media</p>
                  <Slider {...settings}>
                    {this.state.media.map((item, i) => {
                      return (
                        <div>
                          {EXT_IMAGES.test(item.inSite) ? (
                            <React.Fragment>
                              <div className="media_image mb_0 absolute_loader relative">
                                {self.state.imagePreloader || self.state.videoPreLoader ? <Loader /> : ""}
                                <img
                                  src={
                                    item.inSite.includes("http")
                                      ? item.inSite
                                      : self.apiserve.imageUrl + item.inSite
                                  }
                                  alt="image"
                                />
                                <span className="upload_message">
                                  Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB
                                </span>
                                <UploadForm
                                   item={item}
                                   handleImage={e => self.onChangeFile(e, item._id)}
                                   isboth={true}
                                   deleteImage={()=>this.setDeleteImagePopup(item._id)}
                                />
                              </div>
                            </React.Fragment>
                          ) : EXT_VIDEO.test(item.inSite) ? (
                            <React.Fragment>
                              <div className="form_group common_video_upload">
                                <div className="form_group_inner">
                                  <label className="font_500 mb_5">Header Video</label>
                                  <div className="form_group_video loader-main">
                                    <span className="form_note">
                                      Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB
                                    </span>
                                    {/* <img className="uploaded_img" src="https://wowslider.net/local-sliders/demo-10/data1/images/road220058.jpg" /> */}
                                    <div className="form_group_video_wpr">
                                      {self.state.videoPreLoader || self.state.imagePreloader ? (
                                        <Loader />
                                      ) : (
                                        <>
                                          <Player
                                            playsInline
                                            autoPlay={false}
                                            type="video/mp4"
                                            // src={this.apiserve.imageUrl +  this.state.homeVideo}
                                            src={self.apiserve.imageUrl + item.inSite}
                                          >
                                            <ControlBar autoHide={false} disableDefaultControls={true}>
                                              <PlayToggle />
                                            </ControlBar>
                                          </Player>
                                        </>
                                      )}
                                    </div>
                                    <span className={item.inSite ? "input_file active" : "input_file"}>
                                      <input
                                        name="homeVideo"
                                        id="myInput"
                                        type="file"
                                        ref={ref => (self.videoUp = ref)}
                                        onChange={e => self.onChangeFile(e, item._id)}
                                        className="file-upload"
                                        accept=".png, .jpg, .jpeg, .mp4"
                                      />
                                      <PlusIcon
                                        className="video_add_icon"
                                        onClick={() => {
                                          self.videoUp.click();
                                        }}
                                      />
                                    </span>
                                    {this.state.inSite === '' ? '' :
                                      <span className="remove_file pointer "
                                              onClick={()=>this.setDeleteImagePopup(item._id)}
                                        ><DeletefileIcon /></span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : (
                            <div className="media_image mb_0 absolute_loader relative">
                              {self.state.imagePreloader || self.state.videoPreLoader ? <Loader /> : ""}
                              <img src='/images/image-placeholder.png' alt="image" />
                              <span className="upload_message">
                                Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB
                              </span>
                              <UploadForm
                                item={item}
                                handleImage={e => self.onChangeFile(e, item._id)}
                                isboth={true}
                                // deleteImage={()=>this.setDeleteImagePopup()}
                              />
                              
                            </div>
                          )}

                          <div className="field_row">
                            <div className="field_input relative">
                              <input
                                type="text"
                                placeholder="https://cloudfront.aws.com/sdf2345"
                                name="link"
                                value={item.link}
                                onChange={e => this.onPasteLink(e, item._id)}
                                id={item._id}
                              />
                              <span className="copy_box">
                                <CopyIcon />
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
                <div className="fest_right">
                  <div className="field_row">
                    <TextField
                      type="text"
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="field_heading field_row">
                    <p className="fest_field_title">Paragraph 1</p>
                    {/* <div className="heading_bg"></div> */}
                    <div className="field_row_inner">
                      <div className="field_input relative">
                        {/* <textarea></textarea> */}
                        <div className="bg_white">
                          <TextEditor
                            editorState={this.state.paragraph}
                            name="paragraph"
                            value={this.state.paragraph}
                            onEditorStateChange={this.onEditorStateChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="field_heading field_row">
                    <p className="fest_field_title">Body</p>
                    {/* <div className="heading_bg"> </div> */}
                    <div className="field_row_inner">
                      <div className="field_input relative">
                        <TextEditor
                          editorState={this.state.body}
                          name="body"
                          value={this.state.body}
                          onEditorStateChange={this.onEditorState}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text_center field_row w_100 buttons_outer">
                <button className="uppercase">CANCEL</button>
                {/* <button className="uppercase prev_btn">PREviEW</button> */}
                <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecordHTF(e)}>PREviEW</button>
                <button className="uppercase active" type="button" onClick={this.submitFn}>
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
        {this.state.deleteImagePopup
				? <PopUpCustomAll
					HeaderName="Delete Image?"
					insideDetails="Are You Sure ?"
					insideData="You want to delete this image"
					popupState={() => this.closeAdminUser()}
					yesPopUp={() => this.onDeleteImagePopup()} />
				: ""
			}
      </React.Fragment>
    );
  }
}
